export const GET_INVESTMENT = 'GET_INVESTMENT';
export const GET_OPTION_SELECTED = 'GET_INVESTMENT';
